<script lang="ts">
	import type { HTMLAttributes, HTMLInputAttributes } from "svelte/elements";
	import Icon from "../Icon.svelte";
	import checkSimple from "../../../../core/assets/icons/check-simple.svg?raw";

	export let id: string;
	export let checked = false;
	export let name = id;
	export let required = false;
	let formControlClass = "";
	export { formControlClass as class };
	export let errorMessage = "";
	export let showErrorMessage = false;
	export let disabled = false;

	export let labelProps: Omit<HTMLAttributes<HTMLDivElement>, "id"> = {};
	export let inputProps: Omit<HTMLInputAttributes, "id" | "placeholder" | "type" | "required" | "name"> = {};
	export let input: HTMLInputElement | null = null;
</script>

<div class="mt-2 flex gap-3 {formControlClass}">
	<label class="group flex cursor-pointer items-center gap-2">
		<input
			bind:this={input}
			class="peer sr-only"
			{id}
			{required}
			bind:checked
			{disabled}
			{name}
			{...inputProps}
			on:change
			on:input
			type="checkbox"
		/>
		<div
			class="peer-checked:bg-ltprimary-300 group-hover:ring-ltprimary-300 peer-focus-visible:ring-ltprimary-300 flex size-8 shrink-0 items-center justify-center self-start rounded-lg bg-white ring-1 ring-black/50 transition-all group-hover:ring-2 peer-focus-visible:ring-2 [:not(:checked)+&>*]:hidden"
		>
			<Icon icon={checkSimple} class="size-6 text-white" />
		</div>
		<div class="text-neutral text-xs tracking-[0.018rem] lg:text-base" {...labelProps}>
			<slot />
		</div>
	</label>
	{#if showErrorMessage}
		<span class="text-ltdanger px-6 text-[0.8125rem]/tight">{errorMessage}</span>
	{/if}
</div>
